<template>
    <div>
        <div class="main">
            <div class="wp4">
                <div class="page-tit dffs">
                    <router-link class="back-btn" to="/userCenter/newUserIndex"></router-link>
                    电子证信息
                </div>
                <div class="e-card">
                    <div class="left">
                        <div class="pic">
                            <img class="head-photo" :src="guestData.headPhoto" />
                        </div>
                        <div class="text">
                            <div class="tags">
                                <div class="tag" v-for="(item, index) in guestData.guestTypeList" :key="index">{{ item
                                    | mapFilter(guestTypeMap) }}</div>
                            </div>
                            <div class="tit">
                                <span>{{ guestData.guestName }}</span>
                                <p v-if="guestData.guestTypeList.includes('14')">{{ guestData.company }}</p>
                            </div>
                            <div class="info">
                                <p>预约活动：</p>
                                <span v-if="guestData.activityNameList">{{ guestData.activityNameList }}</span>
                                <span v-else class="remind-text">暂无预约数据</span>
                            </div>
                        </div>
                    </div>
                    <div class="qr-wrap">
                        <div class="qr js-openPop" id="#qr" @click="show = true">
                            <img class="code-img" :src="codeUrl" />
                        </div>
                        <p>电子二维码</p>
                        <span>（点击二维码可放大）</span>
                    </div>
                </div>

            </div>
        </div>
        <div class="m-pop qr-pop" id="qr" v-if="show">
            <div class="pop-mask js-close" @click="show = false"></div>
            <div class="pop-con">
                <div class="close js-close" @click="show = false"></div>
                <div class="qr">
                    <img class="code-img" :src="codeUrl" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode';
import { sessionData } from "@/static/js/local.js";
import { industryApi } from '@/api/industry';

const guestTypeMap = new Map([
    ['9', '创投会员'],
    ['10', '创投嘉宾'],
    ['11', '项目方嘉宾'],
    ['13', '市场嘉宾'],
    ['14', '媒体嘉宾'],
    ['15', '发布会嘉宾']
])

export default {
    data() {
        return {
            show: false,
            guestTypeMap: guestTypeMap,
            codeUrl: '',
            guestData: {
                headPhoto: '',
                guestName: '',
                guestTypeList: [],
                activityNameList: []
            }
        };
    },
    created() {
        let userInfo = sessionData("get", "UserInfo");
        if (userInfo && userInfo.accountId) {
            this.getCode(userInfo.accountId);
        } else {
            this.$message.warning('请先登录');
            this.goBack();
        }
    },
    methods: {
        getCode(accountId) {
            industryApi.getCode({
                accountId,
                mainId: this.$session.get("cmm").mainId
            }).then(async res => {
                this.codeUrl = await QRCode.toDataURL(res.data.codeData, {
                    width: 1000,
                    height: 1000
                })
                this.guestData = Object.assign({}, res.data.guestData);
                if (res.data.guestData.activityNameList) {
                    this.guestData.activityNameList = res.data.guestData.activityNameList.join('；');
                }
            })
        },
        goBack() {
            this.$router.push('/userCenter/newUserIndex');
        }
    }
};
</script>
<style scoped></style>
